import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Box from '@redbubble/design-system/react/Box';

import TabList, { Tab } from '../Tabs';
import { getUrlWithLocale } from '../../lib/routing';

import messages from './messages';

const REF = 'explore-tabs';

const ExploreTabs = ({ currentPath, locale }) => {
  return (
    <Box marginBottom={2}>
      <TabList>
        <FormattedMessage {...messages.forYou}>
          {text => (
            <Tab
              to={{
                pathname: getUrlWithLocale(locale, '/explore/for-you'),
                search: `?ref=${REF}`
              }}
              active={currentPath === '/explore/for-you'}
            >
              {text}
            </Tab>
          )}
        </FormattedMessage>
        <FormattedMessage {...messages.feed}>
          {text => (
            <Tab
              to={{
                pathname: getUrlWithLocale(locale, '/explore/feed'),
                search: `?ref=${REF}`
              }}
              active={currentPath === '/explore/feed'}
            >
              {text}
            </Tab>
          )}
        </FormattedMessage>
        <FormattedMessage {...messages.following}>
          {text => (
            <Tab
              to={{
                pathname: getUrlWithLocale(locale, '/explore/following'),
                search: `?ref=${REF}`
              }}
              active={currentPath === '/explore/following'}
            >
              {text}
            </Tab>
          )}
        </FormattedMessage>
      </TabList>
    </Box>
  );
};

ExploreTabs.propTypes = {
  currentPath: PropTypes.string.isRequired,
  locale: PropTypes.string
};

ExploreTabs.defaultProps = {
  locale: 'en'
};

export default ExploreTabs;
